import { Navigate, Outlet, Route, Routes } from "react-router-dom";

import Header from "@/components/navigation/Header";
import { useAuth } from "@/context/auth/AuthContext";
import { PrivateRoute } from "@/navigation/PrivateRoute";
import { PrivateRouteCMS } from "@/navigation/PrivateRouteCMS";
import { PrivateRouteWithInstance } from "@/navigation/PrivateRouteWithInstance";
import AboutUsCMS from "@/pages/cms/about-us.tsx";
import ArtistCMS from "@/pages/cms/artist.tsx";
import ContactCMS from "@/pages/cms/contact.tsx";
import ExpertiseCMS from "@/pages/cms/expertise.tsx";
import NewsCMS from "@/pages/cms/news.tsx";
import SelectionCMS from "@/pages/cms/selection/selection";
import NotFoundPage from "./404";
import CMS from "./cms/homepage";
import AuthCMS from "./cms/login-signup";
import CRCms from "./cms/catalogue-raisonne";
import AddArticlePage from "./cms/e-shop/add-article";
import { CustomerOrders } from "./cms/e-shop/customer-orders";
import EshopCMS from "./cms/e-shop/e-shop";
import { EShopDashboard } from "./cms/e-shop/e-shop-dashboard";
import PoliciesCMS from "./cms/policies";
import Dashboard from "./dashboard";
import ArtworkDashboard from "./dashboard/artwork";
import ArtworkOverview from "./dashboard/artwork-overview";
import AuctionDashboard from "./dashboard/auction";
import AudiovisualDashboard from "./dashboard/audiovisual";
import AuthorDashboard from "./dashboard/author";
import BibliographyDashboard from "./dashboard/bibliography";
import CollectorDashboard from "./dashboard/collector";
import ComptePrincipal from "./dashboard/compte-principal";
import DocumentDashboard from "./dashboard/document";
import ExhibitionDashboard from "./dashboard/exhibition";
import EditForms from "./dashboard/forms";
import { EditAudiovisualPage } from "./dashboard/forms/edit-audiovisual";
import { EditAuthorPage } from "./dashboard/forms/edit-author";
import { EditBibliographyPage } from "./dashboard/forms/edit-biblio";
import { EditCollectorPage } from "./dashboard/forms/edit-collector";
import { EditDocumentPage } from "./dashboard/forms/edit-document";
import { EditExhibitionPage } from "./dashboard/forms/exhibition/edit-exhibition";
import { EditMultiplePrintPage } from "./dashboard/forms/edit-multipleprint";
import { EditArtworksPage } from "./dashboard/forms/artworks/edit-artwork";
import { EditPhotographyPage } from "./dashboard/forms/edit-photography";
import { EditPublicAuctionPage } from "./dashboard/forms/edit-public-auction";
import { EditWritingPage } from "./dashboard/forms/edit-writing";
import MultiprintDashboard from "./dashboard/multiprint";
import PhotographyDashboard from "./dashboard/photography";
import TrashDashboard from "./dashboard/trash";
import WritingDashboard from "./dashboard/writing";
import ForgetPassword from "./forget-password";
import Instance from "./instance";
import Login from "./login";
import { SettingsPage } from "./dashboard/forms/settings";
import EditSection from "./cms/selection/edit-section";
import ManageLayout from "./cms/selection/manage-layout";
import Section from "./cms/selection/section";
import SectionArtworks from "./cms/selection/section-artworks";
import TwoFactor from "./two-factor";
import { Export } from "./dashboard/forms/export/export";
import ArtworkAutheticationCMS from "@/pages/cms/artwork-authentication.tsx";
import ArtworkAuthenticationDetailCMS from "@/pages/cms/artwork-authentication-detail.tsx";

export const AppRouter = () => {
  const { instanceData } = useAuth();

  return (
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/login" element={<Login />} />
      <Route path="/2fa" element={<TwoFactor />} />
      <Route path="/forget-password" element={<ForgetPassword />} />
      <Route
        path="/instance"
        element={
          <PrivateRoute>
            <Instance />
          </PrivateRoute>
        }
      />
      <Route path="/settings" element={<Dashboard />}>
        <Route path="" element={<SettingsPage />} />
      </Route>
      <Route
        path="/dashboard"
        element={<PrivateRouteWithInstance outlet={<Dashboard />} />}
      >
        <Route index element={<Navigate to="artwork" replace />} />
        <Route path={"artwork"} element={<ArtworkDashboard />} />
        <Route path={`exhibition`} element={<ExhibitionDashboard />} />
        <Route path={`bibliography`} element={<BibliographyDashboard />} />
        <Route path={`auction`} element={<AuctionDashboard />} />
        <Route path={`author`} element={<AuthorDashboard />} />
        <Route path={`collector`} element={<CollectorDashboard />} />
        <Route path={`audiovisual`} element={<AudiovisualDashboard />} />
        <Route path={`document`} element={<DocumentDashboard />} />
        <Route path={`writing`} element={<WritingDashboard />} />
        <Route path={`photography`} element={<PhotographyDashboard />} />
        <Route path={`multipleprint`} element={<MultiprintDashboard />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
      <Route
        path="/trash"
        element={
          <PrivateRouteWithInstance
            outlet={
              <>
                <Header />
                <TrashDashboard />
              </>
            }
          />
        }
      />
      <Route
        path={`export`}
        element={<PrivateRouteWithInstance outlet={<Export />} />}
      />
      <Route
        path="/compte-principal"
        element={
          <PrivateRouteWithInstance
            outlet={
              <>
                <Header />
                <ComptePrincipal />
              </>
            }
          />
        }
      />
      <Route
        path="/edit"
        element={<PrivateRouteWithInstance outlet={<EditForms />} />}
      >
        <Route path="artwork/:id" element={<EditArtworksPage />} />
        <Route path="artwork/overview/:id" element={<ArtworkOverview />} />
        <Route path="auction/:id" element={<EditPublicAuctionPage />} />
        <Route path="author/:id" element={<EditAuthorPage />} />
        <Route path="bibliography/:id" element={<EditBibliographyPage />} />
        <Route path="exhibition/:id" element={<EditExhibitionPage />} />
        <Route path="multipleprint/:id" element={<EditMultiplePrintPage />} />
        <Route path="writing/:id" element={<EditWritingPage />} />
        <Route path="photography/:id" element={<EditPhotographyPage />} />
        <Route path="collector/:id" element={<EditCollectorPage />} />
        <Route path="document/:id" element={<EditDocumentPage />} />
        <Route path="audiovisual/:id" element={<EditAudiovisualPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
      <Route
        path="/cms"
        element={
          <PrivateRouteCMS>
            <CMS />
          </PrivateRouteCMS>
        }
      />
      <Route
        path="/cms/artiste"
        element={
          <PrivateRouteCMS>
            <ArtistCMS />
          </PrivateRouteCMS>
        }
      />
      <Route
        path="/cms/about-us"
        element={
          <PrivateRouteCMS>
            <AboutUsCMS />
          </PrivateRouteCMS>
        }
      />
      <Route
        path="/cms/contact"
        element={
          <PrivateRouteCMS>
            <ContactCMS />
          </PrivateRouteCMS>
        }
      />
      <Route
        path="/cms/news"
        element={
          <PrivateRouteCMS>
            <NewsCMS />
          </PrivateRouteCMS>
        }
      />{" "}
      <Route
        path="/cms/selection"
        element={
          <PrivateRouteCMS>
            <SelectionCMS />
          </PrivateRouteCMS>
        }
      />
      <Route
        path="/cms/selection/edit-section/:id?"
        element={
          <PrivateRouteCMS>
            <EditSection />
          </PrivateRouteCMS>
        }
      />
      <Route
        path="/cms/selection/manage-layout"
        element={
          <PrivateRouteCMS>
            <ManageLayout />
          </PrivateRouteCMS>
        }
      />
      <Route
        path="/cms/selection/section/:id"
        element={
          <PrivateRouteCMS>
            <Section />
          </PrivateRouteCMS>
        }
      />
      <Route
        path="/cms/selection/section/:id/artworks"
        element={
          <PrivateRouteCMS>
            <SectionArtworks />
          </PrivateRouteCMS>
        }
      />
      <Route
        path="/cms/expertise"
        element={
          <PrivateRouteCMS>
            <ExpertiseCMS />
          </PrivateRouteCMS>
        }
      />
      <Route
        path="/cms/catalogue-raisonne"
        element={
          <PrivateRouteCMS>
            <CRCms />
          </PrivateRouteCMS>
        }
      />
      <Route
        path="/cms/policies"
        element={
          <PrivateRouteCMS>
            <PoliciesCMS />
          </PrivateRouteCMS>
        }
      />
      <Route
        path="/cms/authentification"
        element={
          <PrivateRouteCMS>
            <AuthCMS />
          </PrivateRouteCMS>
        }
      />
      {instanceData?.haveEshop === true && (
        <>
          <Route
            path="/e-shop"
            element={
              <>
                <Header />
                <div className="px-6 py-4 flex flex-col gap-6">
                  <h1 className="text-3xl font-semibold text-left">
                    Mon e-shop
                  </h1>
                  <Outlet />
                </div>
              </>
            }
          >
            <Route index element={<EShopDashboard />} />
            <Route
              path="customer/:customerEmail"
              element={<CustomerOrders />}
            />
          </Route>
          <Route
            path="/cms/e-shop"
            element={
              <PrivateRouteCMS>
                <EshopCMS />
              </PrivateRouteCMS>
            }
          />
          <Route
            path="/cms/e-shop/ajout"
            element={
              <PrivateRouteCMS>
                <AddArticlePage />
              </PrivateRouteCMS>
            }
          />
        </>
      )}
      <Route
        path="/cms/artwork-authentication"
        element={
          <PrivateRouteCMS>
            <ArtworkAutheticationCMS />
          </PrivateRouteCMS>
        }
      />
      <Route
        path="/cms/artwork-authentication/:id"
        element={
          <PrivateRouteCMS>
            <ArtworkAuthenticationDetailCMS />
          </PrivateRouteCMS>
        }
      />
    </Routes>
  );
};
